import { NavLink } from 'react-router-dom';

export function StewardNav() {
  const cls = ({ isActive }: { isActive: boolean }) => (isActive ? 'subnav__link subnav__link--active' : 'subnav__link');
  return (
    <nav className="subnav" aria-label="Stewardship">
      <NavLink to="/steward" end className={cls}>
        Review queue
      </NavLink>
      <NavLink to="/steward/exports" className={cls}>
        Exports
      </NavLink>
      <NavLink to="/steward/operations" className={cls}>
        Measurement &amp; operations
      </NavLink>
      <NavLink to="/steward/analysis" className={cls}>
        Analysis review
      </NavLink>
    </nav>
  );
}
